const netNumThreeDigit = [ '010', '013', '015', '020', '023', '024', '026', '030', '033', '035', '036', '038', '040',
    '043', '045', '046', '050', '053', '055', '058', '060', '070', '071', '072', '073', '074', '075', '076', '077',
    '078', '079', '085', '088', '097']

function formatInitials(str) {
    let result = ''
    if(str.length) {
        let splitArr = str.split('')
        splitArr.forEach((character, i) => {
            if((/[a-zA-Z]/).test(character)) {
                result += character.toUpperCase() + '.'
            }
        })
    }
    return result
}

function formatIncome(str) {
    let res = ''
    let split = str.toString().split('.')
    let trimmed = split[0].replace(/[^0-9]/g, '')
    if(trimmed.length) {
        res = `€ ${isNaN(parseFloat(trimmed)) ? 0 : parseFloat(trimmed)},-`
    }
    return res
}

function formatPhone(str) {
    let stripped = str.replace(/[^0-9]/g, '')
    let res = stripped
    if(stripped.length > 8) {
        if(stripped.length === 9) {
            stripped = '0' & stripped
        }
        let arr = stripped.split('')
        if(stripped.substring(0,2) === '06') {
            arr.splice(2, 0, ' ')
            arr.splice(5, 0, ' ')
            arr.splice(8, 0, ' ')
            arr.splice(11, 0, ' ')
        } else if(netNumThreeDigit.indexOf(stripped.substring(0,3)) > -1) {
            arr.splice(3, 0, ' ')
            arr.splice(7, 0, ' ')
            arr.splice(10, 0, ' ')
        } else {
            arr.splice(4, 0, ' ')
            arr.splice(7, 0, ' ')
            arr.splice(10, 0, ' ')
        }

        res = arr.join('')
    }
    return res
}

export {
    formatInitials,
    formatPhone,
    formatIncome
}